import { render } from "./AddProductsExpensesModal.vue?vue&type=template&id=8f7286e8"
import script from "./AddProductsExpensesModal.vue?vue&type=script&lang=js"
export * from "./AddProductsExpensesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Invoices/AddProductsExpensesModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f7286e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f7286e8', __exports__)) {
    api.reload('8f7286e8', __exports__)
  }
  
  module.hot.accept("./AddProductsExpensesModal.vue?vue&type=template&id=8f7286e8", () => {
    api.rerender('8f7286e8', render)
  })

}


export default __exports__